import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary-500 text-white py-12 mt-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <img
              src="https://customer-assets.emergentagent.com/job_turnover-expense/artifacts/grzqcm7e_BT_dark_bk.png"
              alt="Betterteem Logo"
              className="h-6 w-auto"
            />
          </div>

          <p className="text-slate-300 mb-4">
            Helping organizations understand and manage employee turnover costs
          </p>

          {/* <div className="flex justify-center items-center space-x-1 text-sm text-slate-500">
            <span>Made with</span>
            <Heart className="h-4 w-4 text-red-400 fill-current" />
            <span>for better workforce management</span>
          </div> */}

          <div className="mt-6 pt-6 border-t border-slate-800 text-xs text-slate-300">
            <p>
              © 2026 Betterteem AI®. Calculations based on industry-standard HR
              metrics and research.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;